import Input from 'antd/lib/input'
import styles from '../../Home.module.less'
import { SearchOutlined } from '@ant-design/icons'
import { Flex, Table, Tag } from 'antd/lib'
import { useCallback, useMemo, useState } from 'react'
import { AttemptHistory, ExamEvaluationStatus } from 'Types/Exams.types'
import { useAttemptHistory } from 'Hooks/exams/use-attempt-history'
import { getFormattedDateTime } from 'Utils/common.utils'

export const HistoryTab: React.FC = () => {
    const columns = useMemo(
        () => [
            {
                title: 'Name',
                dataIndex: 'exam',
                key: 'exam',
                className: styles['history-column'],
                render: (exam: AttemptHistory['exam']) => {
                    return <span>{exam.name}</span>
                },
            },
            {
                title: 'Attempt ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: 'Attempt Number',
                dataIndex: 'attempt_number',
                key: 'attempt_number',
            },
            {
                title: 'Completion Date',
                dataIndex: 'completed_at',
                key: 'completed_at',
                render: (completed_at: string) => {
                    if (!completed_at) {
                        return <span>N/A</span>
                    }
                    return <span>{getFormattedDateTime(completed_at)}</span>
                },
            },
            {
                title: 'Evaluation Status',
                dataIndex: 'evaluation_status',
                key: 'evaluation_status',
                render: (evaluation_status: ExamEvaluationStatus) => {
                    return (
                        <Tag
                            color={
                                evaluation_status === ExamEvaluationStatus.COMPLETED
                                    ? 'green'
                                    : 'orange'
                            }
                        >
                            {evaluation_status}
                        </Tag>
                    )
                },
            },
            {
                title: 'Result',
                dataIndex: 'result',
                key: 'result',
                render: (result: AttemptHistory['result'], { exam }: AttemptHistory) => {
                    const showResult = exam.show_result
                    const attemptResult = result?.AttemptResult
                    if (!showResult) {
                        return <span>N/A</span>
                    }
                    return <span>{attemptResult}</span>
                },
            },
        ],
        []
    )

    const { data, isLoading } = useAttemptHistory()
    const [searchedHistory, setSearchedHistory] = useState('')

    const onSearch = useCallback((value: string) => {
        setSearchedHistory(value)
    }, [])

    const filteredHistory = useMemo(() => {
        return data.filter(attempt => {
            return attempt.exam.name.toLowerCase().includes(searchedHistory.toLowerCase())
        })
    }, [data, searchedHistory])

    return (
        <Flex vertical gap={24} className={styles['history-tab']} data-testid="history-tab">
            <Input
                data-testid="search-input"
                value={searchedHistory}
                className={styles['search-input']}
                placeholder="Search Exam"
                addonAfter={<SearchOutlined />}
                onChange={e => onSearch(e.target.value)}
            />
            <Table<AttemptHistory>
                data-testid="history-table"
                loading={isLoading}
                columns={columns}
                dataSource={filteredHistory}
                pagination={false}
                scroll={{
                    y: 'calc(100vh - 320px)',
                }}
            />
        </Flex>
    )
}
